import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Loading from './common/loading';

const MessageList = ({ isLoading, chats }) => (
  <ol className="chatbox__list">
    {isLoading && <Loading />}
    {chats.map((item) => {
      const liClass = item.sender === 'system' ? 'other' : 'self';
      const timeToString = moment(item.timestamp).isSame(moment(), 'day')
        ? moment(item.timestamp).fromNow()
        : moment(item.timestamp).format('lll');
      return (
        <li
          key={item.id}
          className={`chatbox__item chatbox__item--${liClass}`}
        >
          <div className="chatbox__avatar">
            &nbsp;
          </div>
          <div className="chatbox__message">
            <p className="chatbox__message--text">
              {item.message}
            </p>
            <time>
              {timeToString}
            </time>
          </div>
        </li>
      );
    })}
  </ol>
);
MessageList.defaultProps = {
  chats: {},
  isLoading: false,
};
MessageList.propTypes = {
  chats: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      sender: PropTypes.string.isRequired,
      timestamp: PropTypes.string.isRequired,
      message: PropTypes.string,
    }),
  ),
  isLoading: PropTypes.bool,
};
export default MessageList;
